import {changePassword} from "../../services/Sysadmin/getUsers";
import {useState} from "react";

export const useChangePassword = () => {

    const [changePasswordLoading, setChangePasswordLoading] = useState<boolean>(false);

    const requestUpdatePassword = async (token: string, newPassword: string) => {
        try {
            setChangePasswordLoading(true);
            const response = await changePassword(token, newPassword);
            return response.data.message;
        } catch (error: any) {
            throw error;
        }
        finally {
            setTimeout(() => setChangePasswordLoading(false), 500);
        }
    };

    return { requestUpdatePassword, changePasswordLoading };
};